import { forwardRef } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
// @mui
import { Box, BoxProps, Link } from '@mui/material';

// ----------------------------------------------------------------------

export interface LogoProps extends BoxProps {
  disabledLink?: boolean;
}

const Logo = forwardRef<HTMLDivElement, LogoProps>(
  ({ disabledLink = false, sx, ...other }, ref) => {
    const location = useLocation();

    // OR using local (public folder)
    // -------------------------------------------------------
    const logo = (
      <Box
        component="img"
        // src="logo/fpv.png"
        // src="logo/fpv_black.png"
        // src="logo/fpv_square_white.png"
        // src="logo/fpv_square_black.png"
        // src="logo/fpv_hexagon_rnd.png"
        // src="logo/fpv_typo.png"
        // src="logo/fpv_typo_with_bar.png"
        // src="logo/fpv_white_octagon.png"
        src="/logo/fpv_century_shoolbook_white.png"
        sx={{ height: 64, paddingY: 1, cursor: 'pointer', ...sx }}
      />
    );

    if (disabledLink) {
      return logo;
    }

    return (
      <Link component={RouterLink} to={location.pathname} sx={{ display: 'contents' }}>
        {logo}
      </Link>
    );
  }
);

export default Logo;
